const getConfig = (rootState) => rootState.config;

export default getConfig;
